import React from 'react';
import { connect } from 'react-redux';
import {setTextFilter, sortByDate, sortByAmount, setStartDate, setEndDate} from '../actions/filters';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { orange } from '@mui/material/colors';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';

const ExpenseListFilter = (props) => {

    const primary=orange[800];
    const [startDate, setStart] = React.useState(null);
    const [endDate, setEnd] = React.useState(null);

    return (
        <div className='expense-filter-container'>

            <div className='d-flex flex-wrap expense-filter'>

                <TextField 
                    className="expense-form-input"
                    type="text"
                    id="" 
                    label="Filter" 
                    name=""
                    variant="standard"
                    margin="dense"
                    value={props.filters.text}
                    onChange={(e) => {
                        props.dispatch(setTextFilter(e.target.value))
                    }}
                />

                <TextField 
                    className="expense-form-input"
                    id="" 
                    label="Sort By" 
                    name=""
                    variant="standard"
                    margin="dense"
                    select
                    value={props.filters.sortBy} 
                    onChange={(e) => {
                        if (e.target.value === 'date') {
                            props.dispatch(sortByDate());
                        } else if (e.target.value === 'amount') {
                            props.dispatch(sortByAmount());
                        }
                    }}
                >
                    <MenuItem value="date">Date</MenuItem>
                    <MenuItem value="amount">Amount</MenuItem>
                </TextField>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label="Starting Date"
                        value={startDate}
                        onChange={(e) => {
                            const date=new Date(e).getTime();
                            props.dispatch(setStartDate(date));
                            setStart(e);
                        }}
                        renderInput={(params) => 
                            <TextField 
                                className="expense-form-input" 
                                margin="dense" 
                                variant="standard" 
                                {...params}
                            />
                        }
                    />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                        label="Ending Date"
                        value={endDate}
                        onChange={(e) => {
                            const date=new Date(e).getTime();
                            props.dispatch(setEndDate(date));
                            setEnd(e);
                        }}
                        renderInput={(params) => 
                            <TextField 
                                className="expense-form-input" 
                                margin="dense" 
                                variant="standard" 
                                {...params}
                            />
                        }
                    />
                </LocalizationProvider>

            </div>

            <div className='reset-button'>
                <Button 
                    variant='contained'
                    className='login-logout-button'
                    style={{backgroundColor:primary}}
                    onClick={()=>{
                        props.dispatch(setTextFilter(""));
                        props.dispatch(sortByDate());
                        props.dispatch(setStartDate(-8640000000000000));
                        props.dispatch(setEndDate(8640000000000000));
                        setStart(null);
                        setEnd(null);
                    }}
                >Reset</Button>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filters: state.filters
    }
};

export default connect(mapStateToProps)(ExpenseListFilter);